<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="flexBox">
      <text-title mainTitle="结算配置" subheading="" />
    </div>
    <form>
      <el-card>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-top: -10px">
          <div style="border-left: 5px solid #1362ff; padding: 0 5px">燃气费结算配置</div>
          <div class="header-btn-box" v-if="permissionCodes.indexOf('046004006') !== -1">
            <a @click="modify" v-if="!modifyState && canModify" class="btn"><i class="el-icon-damai-shenpi" style="font-size: 20px"></i>修改</a>
            <a @click="cancel" v-if="modifyState" class="btn">取消</a>
            <a @click="confirm" v-if="modifyState" class="btn">确定</a>
          </div>
        </div>
        <div class="form-line">
          <div class="textBox" style="margin-right: 20px">
            <!--<b class="red">*</b>-->
            <span class="line-text">付费方式：</span>
          </div>
          <el-radio v-model="formData.settlementMethod" label="0" :disabled="!modifyState">预付费</el-radio>
          <el-radio v-model="formData.settlementMethod" label="1" :disabled="!modifyState">后付费</el-radio>
        </div>
        <div class="form-line">
          <div class="textBox" style="margin-right: 20px">
            <!--<b class="red">*</b>-->
            <span class="line-text"
              >结算日<el-tooltip class="item" effect="light" content="结算日用于结算上个月的燃气费" placement="right-start"><i class="el-icon-question" /></el-tooltip>：</span
            >
          </div>
          <el-select v-model="formData.someday" :disabled="!modifyState" placeholder="请选择日期">
            <el-option v-for="item in dateList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
          日结算
        </div>
        <div class="form-line">
          <span class="tip">注：请谨慎设置结算周期，初次设置后将无法修改。</span>
        </div>
      </el-card>
    </form>
  </div>
</template>

<script>
import { errorHandler } from '../../../utils/errorHandler'
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import { api } from '../../api/GasManagement'
import TextTitle from '../../../components/Text/TextTitle'
import { bus } from '../../../utils/bus'
import { nError, nSuccess } from '../../../utils/notice'

export default {
  components: {
    TextTitle,
    Breadcrumb,
  },
  name: 'gas-config-settle',
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: '智慧燃气',
            name: 'gas-over-view',
          },
          {
            value: '结算配置',
          },
        ],
      },
      permissionCodes: '',
      feeType: '',
      ladderData: [],
      modifyState: false,
      canModify: false,
      formData: {},
      dateList: [
        {
          value: '1',
          label: '1',
        },
        {
          value: '2',
          label: '2',
        },
        {
          value: '3',
          label: '3',
        },
        {
          value: '4',
          label: '4',
        },
        {
          value: '5',
          label: '5',
        },
        {
          value: '6',
          label: '6',
        },
        {
          value: '7',
          label: '7',
        },
        {
          value: '8',
          label: '8',
        },
        {
          value: '9',
          label: '9',
        },
        {
          value: '10',
          label: '10',
        },
        {
          value: '11',
          label: '11',
        },
        {
          value: '12',
          label: '12',
        },
        {
          value: '13',
          label: '13',
        },
        {
          value: '14',
          label: '14',
        },
        {
          value: '15',
          label: '15',
        },
        {
          value: '16',
          label: '16',
        },
        {
          value: '17',
          label: '17',
        },
        {
          value: '18',
          label: '18',
        },
        {
          value: '19',
          label: '19',
        },
        {
          value: '20',
          label: '20',
        },
        {
          value: '21',
          label: '21',
        },
        {
          value: '22',
          label: '22',
        },
        {
          value: '23',
          label: '23',
        },
        {
          value: '24',
          label: '24',
        },
        {
          value: '25',
          label: '25',
        },
        {
          value: '26',
          label: '26',
        },
        {
          value: '27',
          label: '27',
        },
        {
          value: '28',
          label: '28',
        },
      ],
    }
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes
    this.getGasSettlementConfig()
  },
  activated() {
    this.getGasSettlementConfig()
  },
  methods: {
    getGasSettlementConfig() {
      this.$axios
        .get(api.getGasSettlementConfig, {})
        .then((res) => {
          this.formData = res.data.data
          this.canModify = this.formData.someday ? false : true
        })
        .catch(errorHandler('获取燃气费结算配置失败'))
    },
    modify() {
      this.modifyState = true
    },
    cancel() {
      this.modifyState = false
      this.getGasSettlementConfig()
    },
    confirm() {
      if (!this.formData.settlementMethod) {
        nError('请选择付费方式')
        return false
      }
      if (!this.formData.someday) {
        nError('请选择结算日期')
        return false
      }
      this.$axios
        .post(api.saveGasSettlementConfig, this.formData)
        .then((res) => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.modifyState = false
            this.getGasSettlementConfig()
          }
        })
        .catch(errorHandler('燃气费结算配置保存失败'))
    },
  },
}
</script>

<style scoped>
.flexBox {
  display: flex;
  justify-content: space-between;
}
.header-btn-box {
  margin: 20px 0 10px 0;
  color: #337ab7;
  font-size: 14px;
}
.header-btn-box a {
  margin-right: 40px;
  cursor: pointer;
}
.header-btn-box a:hover {
  color: #00a0e6;
}
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.form-line > span {
  font-size: 12px;
  color: #97a8be;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 300px;
  /*padding: 0 124px;*/
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.btn {
  display: inline-block;
  width: 74px;
  height: 32px;
  background: #1362ff;
  opacity: 1;
  border-radius: 7px;
  color: #fff;
  text-align: center;
  line-height: 32px;
}
.tip {
  color: #1362ff !important;
  margin-left: 40px;
}
.item {
  color: #1362ff;
}
</style>
<style lang="less">
.approval-manage {
  .approvalBox {
    margin-top: 20px;
  }
}
</style>

<style scoped lang="less">
/deep/.el-card .is-always-shadow {
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/view/GasManage/GasConfigSettle/GasConfigSettle.vue